import { render, staticRenderFns } from "./JumpingFish.vue?vue&type=template&id=39c4d27f&scoped=true"
import script from "./JumpingFish.vue?vue&type=script&lang=js"
export * from "./JumpingFish.vue?vue&type=script&lang=js"
import style0 from "./JumpingFish.vue?vue&type=style&index=0&id=39c4d27f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c4d27f",
  null
  
)

export default component.exports